/** Which connector a Zuganker or Schubanker uses: the prioritization's choice or a fixed one. */
export interface ConnectorSelection {
  policy: ConnectorSelectionPolicy
  /** A project connection's guid; set exactly when `policy` is `UserDefined`. */
  connectorId: string | null
}

export const PRIORITY_LIST_SELECTION: ConnectorSelection = {
  policy: 'PriorityList',
  connectorId: null,
}

export const isSameConnectorSelection = (a: ConnectorSelection, b: ConnectorSelection) =>
  a.policy === b.policy && a.connectorId === b.connectorId
